import { XmlHelper } from "@/helpers/Xml";

export default class XmlComposer {
  public defaultXml: Element;
  public xmlToExport: Element;
  public xmlPostProcessingFunctions: [] | [Function] = [];
  public xmlElementsToRemoveIfEmpty: [] = [];

  constructor(defaultXml: string) {
    this.defaultXml = this.stringToXml(defaultXml) as Element;
    this.xmlToExport = this.defaultXml.cloneNode(true) as Element;
  }

  public stringToXml(xmlString: string): Element | null {
    let xmlDoc = XmlHelper.stringToXmlDocument(xmlString);
    if (xmlDoc) {
      return xmlDoc.firstElementChild;
    }
    return null;
  }

  public resetToDefault() {
    this.xmlToExport = this.defaultXml.cloneNode(true) as Element;
  }

  public setStringToXml(xmlString: string | unknown, silent: boolean = true) {
    if (xmlString) {
      let xmlFromString = this.stringToXml(xmlString as string) as Element;
      //console.log(xmlFromString);
      if (xmlFromString) {
        this.xmlToExport = xmlFromString.cloneNode(true) as Element;
      } else {
        return;
      }

      XmlHelper.formatEmailImport(this.xmlToExport);
      XmlHelper.removeMetadataFromXML(this.xmlToExport);
      window.FormEngine.events.publish(window.FormEngine.events.list.XML_BEFORE_IMPORT, this.xmlToExport);
      window.FormEngine.form.setValuesFromXml(this.xmlToExport, silent);
      window.FormEngine.events.publish(window.FormEngine.events.list.XML_AFTER_IMPORT, this.xmlToExport);
      if (!silent) {
        window.FormEngine.form.validate();
      }

      if (window.FormEngine.form.isValid) {
        // alert("Formulár bol vyplnený správne");
      }
      window.FormEngine.form.setLoading(false);
      this.resetToDefault();
    }
  }

  public getXmlString(): string {
    this.resetToDefault();
    window.FormEngine.events.publish(window.FormEngine.events.list.XML_BEFORE_EXPORT, this.xmlToExport);
    let dom = this.xmlPostprocessing(this.getXml());
    window.FormEngine.events.publish(window.FormEngine.events.list.XML_AFTER_EXPORT, dom);

    let serializer = new XMLSerializer();
    return serializer.serializeToString(dom);
  }

  public xmlPostprocessing(xml: Element): Element {
    XmlHelper.removeMetadataFromXML(xml);

    for (let fn of this.xmlPostProcessingFunctions) {
      fn(xml);
    }
    ////toto treba mat na konci
    //XmlHelper.removeXmlElementsIfEmpty(xml, this.xmlElementsToRemoveIfEmpty);
    XmlHelper.removeXmlElementsIfEmpty(xml);

    return xml;
  }
  /**
   * XML default value klonovacia operacia
   */
  public getXml() {
    let xmlToExport = this.xmlToExport.cloneNode(true) as Element;
    let controls = window.FormEngine.form.getControls().filter((item: any) => {
      return (
        item.state.toExport &&
        !item.mtdt.IsTableDetailElement &&
        item.mtdt.LDT.FieldType !== "Label" &&
        item.mtdt.LDT.FieldType !== "Button" &&
        (item.config.xmlNodeCodeSelector !== "" || item.config.xmlNodeSelector !== "")
      );
    });
    controls.forEach((control: any) => {
      control.handleXmlExport(xmlToExport,xmlToExport);
    });
    return xmlToExport;
  }
}
